import { action, observable, decorate, computed, toJS } from "mobx";
import { getPageWarningCountNonAdmin } from "../../helpers"
import userStore from "./UserStore"
import ibsStore from "./IbsSurveyStore"
import { SurveyTypeURL, PATH_SURVEY_TYPE_MAP, PABS_SURVEY_MAP, DEFAULT_SURVEY_TYPE, DEFAULT_LOCALE } from "../../Enums/constants";
import SharedStore from "./SharedStore";
import { checkIfAnalyst } from "../../Services/IBS/IbsService";

class PabsSurveyStore {
    availableSurveys = [""]; //need alt
    allAvailableSurveys = []; 
    availablePlanProducts = []; 
    availableUserPlanRoles = [];
    pabsSurveysList = [];
    pabsSurveyStatusTypes = [];
    
    currentSurvey = [null];
    currentYear = 2023;
    previousYearValue = null;
    allPageResponses = {
        combined: []
    };
    showLogoutModal = false;
    showDeleteRowModal = false;
    showMandateActionModal = false;
    addingNewMandate = false;
    editingMandate = false;
    addingBenchmark = false;
    showPrintModal = false;
    showAdminPanel = false; // TODO cleanup, used to be the laundromat modal flag
    showCommentModal = false;
    showErrorCommentModal = false;
    showAddRowModal = false;
    showInternalTeamModal = false;
    showCustomGroupingModal = false;

    loadingErrorSummaryDone = true;

    //comment info status
    commentAnalystContent = { "ProvidedValue": "", "CurrentValue": "", "EditedBy": "", "DateModified": "", "Comment": "", "TempComment": "", "QuestionName": "" };
    errorCommentContent = { "ErrorId":"", "CurrentValue": "", "WarningFeedback": "", "ErrorExplanation": "", "TempErrorExplanation": "", "QuestionName": "" , "ErrorType":"", "RowID":""};
    surveyPreparerContent = { "Id": "", "FirstName": "", "LastName": "", "Email": "", "Roles": "", "tempFirstName": "", "tempLastName": "", "tempEmail": "", "tempRoles": "" };
    databaseConnection = true;

    //row
    rowDetails = { "AssetClassId": "", "CategoryId": "", "AssetClassName": "", "ImplementationStyleName": "", "ImplementationStyleId": "", "TableName": "", "AssetClassDescription":"This asset style is valid (description here)","StyleDescription":"This asset style is valid when a (description here)"}
    showAssetOptions = true
    showImplementationOptions = false
    showSubstylesOptions = false
    rowToDelete = {"RowID":"", "TableName":""}

    //modes
    questionMode = false;
    analystMode = false;
    developerMode = false;

    filterTagsNew = { "surveyTypeDesc": [], "countryName": [], "dataYear": [] };
    allValidationErrorsList = {};
    currentURL = "";
    additionalInfoPanel = {
        visible: false,
        name:""
    }

    prevYearPanel = {
        visible: false,
        name: "",
        value: null,
        loading: false
    }

    availPageTitles = []
    showSideNav = true;
    loadingSurvey = true;
    surveyMappingObj = {};
    surveyAllErrors = []

    //Need to be able to remve the number of overridden errors
    overridenErrors = {};
    overridenWarnings = {};

    yourBenchmarkSummary = {};
    
    printMode = false;
    printSettings = {};

    surveyCleanersPABS = null;
    surveyCleanersMapPABS = null;

    updateSurveyField = (surveyId, field, value) => {
        const survey = this.pabsSurveysList.find(s => s.surveyId === surveyId);
        if (survey) {
            survey[field] = value;
        }
    };

    clearAllPageResponses() {
        this.allPageResponses = {
            combined: []
        };
    }

    //get the page that the user is currently on
    get currentLandedPage() {
        const currentPage = this.currentURL.split("/").slice(-1)[0].trim().toLowerCase().split("#")[0];
        return (currentPage);
    }

    //get the responses for the questions of the current page (this data is already gathered during init, here it switches to the correct list of responses)
    get currentPageResponse() {
        return (this.allPageResponses[this.currentLandedPage])
    }

    get isAvailableSurveysEmpty() {
        return this.availableSurveys.length === 0 || (this.availableSurveys.length === 1 && this.availableSurveys[0] == "")
    }

    //Get the floating page error list
    get pageFloatingErrors() {
        var list = [];
        if (this.allValidationErrorsList[this.currentLandedPage]) {
            for (var i = 0; i < this.allValidationErrorsList[this.currentLandedPage].length; i++) {
                if (this.allValidationErrorsList[this.currentLandedPage][i].isPageError && this.allValidationErrorsList[this.currentLandedPage][i].ErrorTypeID == 0) {
                    list.push(this.allValidationErrorsList[this.currentLandedPage][i]);
                }
            }
        }
        return list;
    }
    //Get the floating page warning list
    get pageFloatingWarnings() {
        var list = [];
        if (this.allValidationErrorsList[this.currentLandedPage]) {
            for (var i = 0; i < this.allValidationErrorsList[this.currentLandedPage].length; i++) {
                if (this.allValidationErrorsList[this.currentLandedPage][i].isPageError && this.allValidationErrorsList[this.currentLandedPage][i].ErrorTypeID > 0) {
                    list.push(this.allValidationErrorsList[this.currentLandedPage][i]);
                }
            }
        }
        return list;
    }

    //Get the error count for the page currently on 
    get pageErrorCount() {
        var i;
        var count = 0;
        if (this.allValidationErrorsList[this.currentLandedPage]) {
            for (i = 0; i < this.allValidationErrorsList[this.currentLandedPage].length; i++) {
                if (this.allValidationErrorsList[this.currentLandedPage][i].ErrorTypeID == 0 && ((this.allValidationErrorsList[this.currentLandedPage][i].IsAdminOnly == false) || this.surveyTypeUrl === SurveyTypeURL.DB || this.surveyTypeUrl === SurveyTypeURL.DC)) {
                    count = count + 1;

                }
            }
        }
        return count;
    }

    //Get the warning count for the page currently landed on
    get pageWarningCount() {
        var i;
        var count = 0;
        if (this.allValidationErrorsList[this.currentLandedPage]) {
            for (i = 0; i < this.allValidationErrorsList[this.currentLandedPage].length; i++) {
                if (this.allValidationErrorsList[this.currentLandedPage][i].ErrorTypeID > 0 && !this.allValidationErrorsList[this.currentLandedPage][i].ErrorExplanation && (this.allValidationErrorsList[this.currentLandedPage][i].IsAdminOnly == false || this.surveyTypeUrl === SurveyTypeURL.DB || this.surveyTypeUrl === SurveyTypeURL.DC)) {
                    count = count + 1;
                }
            }
            //if (this.surveyTypeUrl === SurveyTypeURL.DC || this.surveyTypeUrl === SurveyTypeURL.DB) {
            //    for (i = 0; i < this.allValidationErrorsList[this.currentLandedPage].length; i++) {
            //        if (this.allValidationErrorsList[this.currentLandedPage][i].ErrorTypeID > 0 && !this.allValidationErrorsList[this.currentLandedPage][i].ErrorExplanation) {
            //            count = count+1
            //        }
            //    }
            //}
        }
        return count;
    }

    //get the error count for the page currently on 
    get pageErrors() {
        var list = [];
        var i;
        if (this.allValidationErrorsList[this.currentLandedPage]) {
            for (i = 0; i < this.allValidationErrorsList[this.currentLandedPage].length; i++) {
                if (this.allValidationErrorsList[this.currentLandedPage][i].ErrorTypeID == 0 && ((this.allValidationErrorsList[this.currentLandedPage][i].IsAdminOnly == false) || this.surveyTypeUrl === SurveyTypeURL.DB || this.surveyTypeUrl === SurveyTypeURL.DC)) {
                    list.push(this.allValidationErrorsList[this.currentLandedPage][i]);

                }
            }
        }
        return list;
    }

    //Get the warning count for the page currently landed on
    get pageWarnings() {
        var list = [];
        var i;
        if (this.allValidationErrorsList[this.currentLandedPage]) {
            for (i = 0; i < this.allValidationErrorsList[this.currentLandedPage].length; i++) {
                if (this.allValidationErrorsList[this.currentLandedPage][i].ErrorTypeID > 0 && !this.allValidationErrorsList[this.currentLandedPage][i].ErrorExplanation && (this.allValidationErrorsList[this.currentLandedPage][i].IsAdminOnly == false || this.surveyTypeUrl === SurveyTypeURL.DB || this.surveyTypeUrl === SurveyTypeURL.DC)) {
                    list.push(this.allValidationErrorsList[this.currentLandedPage][i]);
                }
            }
            //if (this.surveyTypeUrl === SurveyTypeURL.DC || this.surveyTypeUrl === SurveyTypeURL.DB) {
            //    for (i = 0; i < this.allValidationErrorsList[this.currentLandedPage].length; i++) {
            //        if (this.allValidationErrorsList[this.currentLandedPage][i].ErrorTypeID > 0 && !this.allValidationErrorsList[this.currentLandedPage][i].ErrorExplanation) {
            //            count = count+1
            //        }
            //    }
            //}
        }
        return list;
    }
    //Get the warning count for error mapped cells
    get cellErrorCount() {
        var activeFloatingErrors = 0;
        if (this.allValidationErrorsList[this.currentLandedPage]) {
            for (var i = 0; i < this.allValidationErrorsList[this.currentLandedPage].length; i++) {
                if (this.allValidationErrorsList[this.currentLandedPage][i].ErrorTypeID == 0 && this.allValidationErrorsList[this.currentLandedPage][i].isPageError && !this.allValidationErrorsList[this.currentLandedPage][i].ErrorExplanation && (this.allValidationErrorsList[this.currentLandedPage][i].IsAdminOnly == false || this.surveyTypeUrl === SurveyTypeURL.DB || this.surveyTypeUrl === SurveyTypeURL.DC)) {
                    activeFloatingErrors = activeFloatingErrors + 1;
                }
            }
        }
        return this.pageErrorCount - activeFloatingErrors - Object.keys(this.overridenErrors).length;
    }

    //Get the warning count for warnings mapped cells
    get cellWarningCount() {
        var activeFloatingWarnings = 0;
        if (this.allValidationErrorsList[this.currentLandedPage]) {
            for (var i = 0; i < this.allValidationErrorsList[this.currentLandedPage].length; i++) {
                if (this.allValidationErrorsList[this.currentLandedPage][i].ErrorTypeID > 0 && this.allValidationErrorsList[this.currentLandedPage][i].isPageError && !this.allValidationErrorsList[this.currentLandedPage][i].ErrorExplanation && (this.allValidationErrorsList[this.currentLandedPage][i].IsAdminOnly == false || this.surveyTypeUrl === SurveyTypeURL.DB || this.surveyTypeUrl === SurveyTypeURL.DC)) {
                    activeFloatingWarnings = activeFloatingWarnings + 1;
                }
            }
        }
        return this.pageWarningCount - activeFloatingWarnings - Object.keys(this.overridenWarnings).length;
    }

    //based on the number of critical errors style the block
    get errorBlockStyle() {
        /*if (this.pageErrorCount > 0) {
            return "alert alert-danger alert-dismissible fade-in"
        }*/
        return "alert alert-warning alert-dismissible fade-in"
    }

    //filter the errors from the generic error/warning list
    get errorSummary() {
        var list = [];
        for (var x = 0; x < this.surveyAllErrors.length; x++) {
            if (this.surveyAllErrors[x].ErrorCount > 0) {
                list.push(this.surveyAllErrors[x].Page);
            }
        }
        return (list)
    }

    get allWarnings() {
        var list = [];
        for (var x = 0; x < this.surveyAllErrors.length; x++) {
            if (this.surveyAllErrors[x].WarningCount > 0) {
                list.push(this.surveyAllErrors[x].Page);
            }
        }
        return (list)
    }

    //filter the warnings from the generic error/warning list
    get warningSummary() {
        const list = [];
        for (let x = 0; x < this.surveyAllErrors.length; x++) {
            if (getPageWarningCountNonAdmin(this.surveyAllErrors[x].Page) > 0) {
                list.push(this.surveyAllErrors[x].Page);
            }
        }
        return (list)
    }

    //get the path for next page (used for next section button)
    get nextPagePath() {
        var uppercaseAvailTitles = this.availPageTitles.map(function (value) {
            // I suspect this "Mandate level" replace(" ", "_") should be removed, as none of the other paths have a underscore in them
            if (value === "Mandate Level") return value.toUpperCase().replace(" ", "_")
            if (value === "Td&Balanced") return value.toUpperCase().replace("&", "")
            return value.toUpperCase().replace(" ","");
        });
        var index = uppercaseAvailTitles.indexOf(this.currentLandedPage.toUpperCase())
        if (index >= 0 && uppercaseAvailTitles[index + 1]) return (this.surveyTypeUrl + uppercaseAvailTitles[index + 1].toLowerCase());
        if (index==uppercaseAvailTitles.length-1) return (this.surveyTypeUrl + "submit");

        
    }
    //get the path for prev page (used for prev section button)
    get previousPagePath() {
        try {
            var uppercaseAvailTitles = this.availPageTitles.map(function (value) {
                if (value === "Mandate Level") return value.toUpperCase().replace(" ", "_")
                if (value === "Td&Balanced") return value.toUpperCase().replace("&", "")
                return value.toUpperCase().replace(" ", "");
            });
            var index = uppercaseAvailTitles.indexOf(this.currentLandedPage.toUpperCase())
            if (index >= 0 && uppercaseAvailTitles[index - 1]) return (this.surveyTypeUrl + uppercaseAvailTitles[index - 1].toLowerCase());
            if (this.currentLandedPage.toLowerCase() == "submit") return (this.surveyTypeUrl + uppercaseAvailTitles[uppercaseAvailTitles.length - 1].toLowerCase())
            return (this.surveyTypeUrl + uppercaseAvailTitles[0].toLowerCase());
        } catch (e){
            return null;
        }
       
    }

    get isPabsSurvey() {
        return this.surveyTypeUrl === SurveyTypeURL.PABS || this.surveyTypeUrl === SurveyTypeURL.PABS_UK || this.surveyTypeUrl === SurveyTypeURL.PABS_LG;
    }
    
    //get the type of survey and return the respected url tag (SHARED)
    // TODO PABS: Rewrite this function
    get surveyTypeUrl() {
        const surveyTypeId = this.currentSurvey?.SurveyTypeId;
        const surveyTypeKey = PABS_SURVEY_MAP[surveyTypeId]?.type || DEFAULT_SURVEY_TYPE;
        if (surveyTypeKey) {
            return SurveyTypeURL[surveyTypeKey] || surveyTypeKey;
        } 
        
        if (window.location.href.includes("/dc")) {
          return SurveyTypeURL.DC
        } else if (window.location.href.includes('/pabslg')) {
          return SurveyTypeURL.PABS_LG
        } else if (window.location.href.includes('/pabsuk')) {
          return SurveyTypeURL.PABS_UK
        } else if (window.location.href.includes('/pabs')) {
          return SurveyTypeURL.PABS
        } else if (window.location.href.includes('/db')) {
          return SurveyTypeURL.DB
        } else if (window.location.href.includes('/ibs')) {
          return SurveyTypeURL.IBS
        }
        
        // Currently commented off because it's not ready to be used yet. the above is still working more reliably
        // Fallback to path-based lookup
        // TODO PABS: activating the fallback because defaultsurveytype is "", which is falsy, which doesnt trip the surveyTypeKey check, is rather gross
        // const path = window.location.pathname.toLowerCase();
        // for (const key in PATH_SURVEY_TYPE_MAP) {
        //     // TODO PABS: /pabsuk includes /pabs and a few other edge cases !!
        //     // Eliminated for now by making /pabs the last to be compared against, but should be properly fixed
        //     if (path.includes(key)) return PATH_SURVEY_TYPE_MAP[key];
        // }
        
        return ''
    }
    
    get local() {
        return PABS_SURVEY_MAP[this.currentSurvey?.SurveyTypeId]?.locale || DEFAULT_LOCALE;
    }

    //check to see if the user is allowed to edit read only (if analyst and the survey is read only, they are allowed to edit)
    get userCanEditReadOnlySurvey() {
        if (typeof this.currentSurvey !== 'undefined' && this.currentSurvey != null && typeof this.currentSurvey.IsReadOnly !== 'undefined') {
            if (this.currentSurvey.IsReadOnly && userStore.accountInfo.isAnalyst) {
                return true;
            } else if (this.currentSurvey.IsReadOnly && !userStore.accountInfo.isAnalyst) {
                return false;
            } else {
                return true;
            }
        }
        else if (typeof ibsStore.currentSurvey !== 'undefined' && ibsStore.currentSurvey != null && typeof ibsStore.currentSurvey.SurveyStatusID !== 'undefined') {
            var isSubmitted = ibsStore.currentSurvey.SurveyStatusID != null && ibsStore.currentSurvey.SurveyStatusID != 0;//any validated value, could also be null
            var isAnalyst = checkIfAnalyst()
            let isLocked = ibsStore.currentSurvey.IsLocked || ibsStore.currentSurvey.SurveyStatusID == 1

            if (isLocked && !isAnalyst) return false
            
            if (isSubmitted) {
                if (isAnalyst) {
                    return true;
                }
                else {
                    return false;
                }
            } else if (ibsStore.currentSurvey.DataYear < SharedStore.currentDataYear) {
                if (isAnalyst) {
                    return true;
                }
                else {
                    
                }
            }

        }
        return true;
    }

}

decorate(PabsSurveyStore, {
    isPabsSurvey: computed,
    surveyTypeUrl: computed,
    userCanEditReadOnlySurvey:computed,
    yourBenchmarkSummary: observable,
    local:computed,
    databaseConnection: observable,
    loadingErrorSummaryDone: observable,
    currentURL: observable,
    warningSummary: computed,
    errorSummary: computed,
    surveyType: observable,
    surveyResponse: observable,
    assetResponse: observable,
    surveyContainsError: observable,
    dataTablesResponse: observable,
    availableSurveys: observable,
    allAvailableSurveys:observable,
    availablePlanProducts: observable,
    surveyPreparers: observable,
    allPageResponses: observable,
    currentPageResponse: computed,
    currentSurvey: observable,
    currentYear: observable,
    previousYearValue: observable,
    currentLandedPage: computed,
    questionMode: observable,
    analystMode: observable,
    developerMode: observable,
    accountInfo: observable,
    showHelpModal: observable,
    showLogoutModal:observable,
    showPrintModal: observable,
    showAdminPanel: observable,
    showCommentModal: observable,
    showMandateActionModal:observable,
    commentAnalystContent: observable,
    errorCommentContent: observable,
    pabsSurveysList: observable,
    pabsSurveyStatusTypes: observable,
    surveyListDisplay: observable,
    lockSurvey: observable,
    filterTagsNew: observable,
    allValidationErrorsList: observable,
    surveyPreparerContent: observable,
    showErrorCommentModal: observable,
    pageErrorCount: computed,
    pageFloatingErrors: computed,
    surveyValidated: observable,
    surveyAllErrors: observable,
    additionalInfoPanel: observable,
    prevYearPanel: observable,
    loadingSurvey:observable,
    showSideNav: observable,
    laundromatSelectedRow: observable, 
    showAddRowModal: observable, 
    rowDetails: observable, 
    showAssetOptions: observable, 
    showImplementationOptions: observable,
    showDeleteRowModal: observable,
    showInternalTeamModal: observable, 
    showCustomGroupingModal: observable, 
    editingMandate: observable, 
    addingBenchmark:observable,
    addingNewMandate: observable,
    overridenErrors: observable,
    overridenWarnings: observable,
    printMode: observable,
    printSettings: observable,
    updateSurveyField: action,
    surveyCleanersPABS: observable,
    surveyCleanersMapPABS: observable,
});

export default new PabsSurveyStore();